import { render, staticRenderFns } from "./CadastroFornecedor.vue?vue&type=template&id=7f202ef2&scoped=true"
import script from "./CadastroFornecedor.vue?vue&type=script&lang=js"
export * from "./CadastroFornecedor.vue?vue&type=script&lang=js"
import style0 from "./CadastroFornecedor.vue?vue&type=style&index=0&id=7f202ef2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f202ef2",
  null
  
)

export default component.exports